import axios from 'axios';
import { retryOperation } from './retryOperation';

let promise: Promise<string> | null = null;

export async function generateCsrfToken(): Promise<string> {
    if (!promise) {
        promise = retryOperation<string>(async () => {
            const response = await axios.get('/csrf_token');

            if (response.data?.sk) {
                setTimeout(
                    () => {
                        promise = null;
                        generateCsrfToken();
                    },
                    (response.data['max-age-seconds'] - 300) * 1_000,
                );

                return response.data?.sk;
            }

            throw new Error('Не удалось сгенерировать CSRF токен');
        }).catch(() => {
            promise = null;
            throw new Error('Не удалось сгенерировать CSRF токен');
        });
    }

    return promise;
}
